import { createGlobalStyle } from 'styled-components'

/**
 * Ant Design sets `html, body { height: 100% }`. Combined with a leftover
 * `overflow: hidden` from the Reports modal (or antd Modal), that kills
 * vertical scroll on every page. Keep the document as the scroller.
 * The reports modal still locks background scroll via its own class.
 */
export default createGlobalStyle`
    html, body {
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      height: auto !important;
      min-height: 100% !important;
      overflow-x: hidden;
      overflow-y: auto !important;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }

    #root {
      min-height: 100%;
    }

    /* A table rendered inside a flex parent never shrinks below its content
       width (flex items default to min-width: auto), so the antd scroll
       container grows as wide as the table itself and overflow-x never
       triggers — the page just clips. Let the wrapper shrink so the inner
       .ant-table-body becomes the horizontal scroller. */
    .ant-table-wrapper {
      min-width: 0;
      max-width: 100%;
    }

    /* macOS/overlay scrollbars hide table scroll affordance entirely, so
       users think wide tables are simply cut off. Always show a classic
       horizontal scrollbar on scrolling antd table bodies/headers. */
    .ant-table-body::-webkit-scrollbar,
    .ant-table-header::-webkit-scrollbar,
    .ant-table-scroll::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 10px;
    }

    .ant-table-body::-webkit-scrollbar-track,
    .ant-table-header::-webkit-scrollbar-track,
    .ant-table-scroll::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.06);
      border-radius: 5px;
    }

    .ant-table-body::-webkit-scrollbar-thumb,
    .ant-table-header::-webkit-scrollbar-thumb,
    .ant-table-scroll::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.35);
      border-radius: 5px;
      min-width: 40px;
    }

    .ant-table-body,
    .ant-table-header,
    .ant-table-scroll {
      scrollbar-width: thin;
    }

    /* Keep every table's pagination arrows visually consistent
       (same centering rule Catalogue/Invoices already applied locally). */
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
`
